
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useAdminCheckQuery = () => {
  return useQuery({
    queryKey: ['adminCheck'],
    queryFn: async () => {
      console.log('Checking admin status...');
      const { data: hasAdminRole, error } = await supabase.rpc('has_role', {
        _role: 'admin'
      });

      if (error) {
        console.error('Error checking admin status:', error);
        return false;
      }
      
      console.log('Admin status:', hasAdminRole);
      return !!hasAdminRole; // Ensure we return a boolean value
    },
    staleTime: 30 * 60 * 1000, // 30 minutes
    refetchOnWindowFocus: false,
  });
};
